import angular from 'angular';
import enCA from './locale-en_CA.json';
import frCA from './locale-fr_CA.json';

const injectorName = 'wsDirectivesTranslations';
export default injectorName;

angular.module(injectorName, [])
  .config(TranslationsConfig);

TranslationsConfig.$inject = ['$translateProvider'];
function TranslationsConfig($translateProvider) {
  $translateProvider.translations('en_CA', enCA);
  $translateProvider.translations('fr_CA', frCA);
}



// WEBPACK FOOTER //
// ./src/translations/index.js